import React from 'react';
import './index.css';
import 'config/dayjs';
import Main from './layouts/app-main';
import { createRoot } from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ThemeProvider } from 'flowbite-react';
import { ThemeInit } from '../.flowbite-react/init';
import { ENV } from 'config/env';

const rootElement = document.getElementById('root');

const flowbiteTheme = {
  button: {
    color: {
      unstyled: '',
      default:
        'bg-primary hover:bg-primary-dark text-white shadow-md shadow-primary/30 focus:ring-primary',
      primary:
        'bg-primary hover:bg-primary-dark text-white shadow-md shadow-primary/30 focus:ring-primary',
      secondary:
        'bg-secondary hover:brightness-95 text-white shadow-md shadow-secondary/30 focus:ring-secondary',
      warning:
        'bg-amber-500 hover:bg-amber-600 text-white shadow-md shadow-amber-500/30 focus:ring-amber-500',
      danger:
        'bg-red-600 hover:bg-red-700 text-white shadow-md shadow-red-500/30 focus:ring-red-500',
      info: 'bg-sky-500 hover:bg-sky-600 text-white shadow-md shadow-sky-500/30 focus:ring-sky-500',
      success:
        'bg-emerald-500 hover:bg-emerald-600 text-white shadow-md shadow-emerald-500/30 focus:ring-emerald-500',
      neutral:
        'bg-gray-700 hover:bg-gray-800 text-white shadow-md shadow-gray-500/30 focus:ring-gray-500',
      text: 'bg-transparent text-gray-500 shadow-none hover:bg-gray-100 hover:text-gray-900',
      light:
        'bg-white border border-gray-200 hover:border-gray-300 hover:bg-gray-100 text-gray-700 shadow-sm',
      blue: 'bg-blue-600 hover:bg-blue-700 text-white shadow-md shadow-blue-500/30 focus:ring-blue-500',
      red: 'bg-red-600 hover:bg-red-700 text-white shadow-md shadow-red-500/30 focus:ring-red-500',
      green:
        'bg-green-600 hover:bg-green-700 text-white shadow-md shadow-green-500/30 focus:ring-green-500',
      gray: 'bg-gray-700 hover:bg-gray-800 text-white shadow-md shadow-gray-500/30 focus:ring-gray-500',
      amber:
        'bg-amber-500 hover:bg-amber-600 text-white shadow-md shadow-amber-500/30 focus:ring-amber-500',
      orange:
        'bg-orange-500 hover:bg-orange-600 text-white shadow-md shadow-orange-500/30 focus:ring-orange-500',
      yellow:
        'bg-yellow-500 hover:bg-yellow-600 text-white shadow-md shadow-yellow-500/30 focus:ring-yellow-500',
      cyan: 'bg-cyan-500 hover:bg-cyan-600 text-white shadow-md shadow-cyan-500/30 focus:ring-cyan-500',
      'light-blue':
        'bg-sky-500 hover:bg-sky-600 text-white shadow-md shadow-sky-500/30 focus:ring-sky-500',
      'blue-gray':
        'bg-slate-600 hover:bg-slate-700 text-white shadow-md shadow-slate-500/30 focus:ring-slate-500',
      failure:
        'bg-red-600 hover:bg-red-700 text-white shadow-md shadow-red-500/30 focus:ring-red-500',
    },
  },
  spinner: {
    color: {
      secondary: 'fill-gray-600',
      blue: 'fill-blue-600',
      green: 'fill-green-600',
      lightBlue: 'fill-light-blue-600',
      light: 'fill-gray-300',
    },
  },
  modal: {
    root: {
      sizes: {
        xs: 'max-w-xs',
      },
    },
    content: {
      inner: 'relative flex max-h-[90dvh] flex-col overflow-y-auto rounded-lg bg-white shadow',
    },
  },
};

const renderApp = (Component) => {
  createRoot(rootElement).render(
    <GoogleOAuthProvider clientId={ENV.GOOGLE_CLIENT_ID}>
      <ThemeInit />
      <ThemeProvider theme={flowbiteTheme}>
        <Component />
      </ThemeProvider>
    </GoogleOAuthProvider>
  );
};

renderApp(Main);

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
